import React from 'react';
import ImpContainer from '../../Atoms/ImpContainer/ImpContainer';
import ImpFlex from '../../Atoms/ImpFlex/ImpFlex';
import ImpText from '../ImpText/ImpText';
import styled from 'styled-components';
import ImpIcon from '../ImpIcon/ImpIcon';
import { colors } from '../../DesignSystem/colors';
import ImpFlexItem from '../../Atoms/ImpFlexItem/ImpFlexItem';
const CIRCLE_SIZE = '32px';
const CIRCLE_BORDER_RADIUS = '16px';
const CIRCLE_BORDER = `1px solid ${colors.border.borderVariant}`;
const CONNECTOR_INCOMPLETE_COLOR = colors.surface.surfaceTrack;
const CONNECTOR_COMPLETE_COLOR = 'var(--merchant-color)';
const ICON_INCOMPLETE_COLOR = colors.content.onSurfaceDisabled;
const ICON_COMPLETE_COLOR = 'var(--merchant-color)';
const CONNECTOR_HEIGHT = '8px';
const COMPLETE_BACKGROUND_COLOR = colors.surface.surfaceHigh;
const INCOMPLETE_BACKGROUND_COLOR = colors.surface.surfaceHigh;
const COMPLETE_COLOR = 'var(--merchant-color)';
const INCOMPLETE_COLOR = colors.content.onBackground;
export const TRANSITION_DURATION_MS = 600;
export const TRANSITION_DURATION = '0.6s';
const ProgressBar = styled(ImpContainer) `
  background-color: ${CONNECTOR_INCOMPLETE_COLOR};
  position: relative;
  margin: 12px 0px;
  border-radius: 4px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: ${CONNECTOR_HEIGHT};
    width: ${(props) => props.progressState === 'complete'
    ? '100%'
    : props.progressState === 'current'
        ? '50%'
        : '0%'};
    background-color: ${CONNECTOR_COMPLETE_COLOR};
    transition: width ${TRANSITION_DURATION};
    transition-delay: ${(props) => props.transitionDelay};
    border-radius: 4px;
  }
`;
const Circle = styled(ImpContainer) `
  background-color: ${(props) => props.complete ? COMPLETE_BACKGROUND_COLOR : INCOMPLETE_BACKGROUND_COLOR};
  transition: background-color ${TRANSITION_DURATION} ${TRANSITION_DURATION};

  position: relative;
  z-index: 1;

  box-shadow: ${(props) => props.complete ? `0px 2px 6px 0px #0000001f` : `none`};

  transition: box-shadow ${TRANSITION_DURATION} ${TRANSITION_DURATION};

  ${(props) => props.position === 'end' && `margin-right: -1px;`}
`;
const OnTopItem = styled(ImpContainer) `
  position: absolute;
  left: 0;
  z-index: 1;

  flex: 0 0 auto;
  min-width: min-content;

  ${(props) => props.position === 'middle' && `transform: translateX(-50%);`}
  ${(props) => props.position === 'end' && `transform: translateX(-100%);`}
`;
export default function ImpTrackerItem({ label = 'X', labelIcon = undefined, state = 'incomplete', position = 'start', transitionDelay = '0s', }) {
    return (React.createElement(ImpContainer, { width: "100%", position: "relative" },
        React.createElement(ImpFlex, { direction: "row", align: "flex-start", justify: "flex-start", dataTestId: "progress-bar-item-flex" },
            React.createElement(ImpFlexItem, { flex: "0 0 auto" },
                React.createElement(ItemContent, { position: position, state: state, label: label, labelIcon: labelIcon })),
            !(position === 'end') && (React.createElement(ImpFlexItem, { flexGrow: 1 },
                React.createElement(ProgressBar, { width: "100%", progressState: state, height: CONNECTOR_HEIGHT, transitionDelay: transitionDelay, dataTestId: "progress-bar" }))))));
}
const TextContainer = styled(ImpContainer) `
  white-space: nowrap;
  transition: color ${TRANSITION_DURATION} ${TRANSITION_DURATION};
`;
function ItemContent({ position, state, label, labelIcon, }) {
    const align = position === 'middle'
        ? 'center'
        : position === 'start'
            ? 'flex-start'
            : 'flex-end';
    const content = () => {
        if (labelIcon) {
            return (React.createElement(ImpIcon, { iconSrc: labelIcon, stroke: state === 'complete' || state === 'current'
                    ? ICON_COMPLETE_COLOR
                    : ICON_INCOMPLETE_COLOR, size: "20px", transition: `stroke ${TRANSITION_DURATION} ${TRANSITION_DURATION}`, strokeWidth: "3" }));
        }
        else {
            return (React.createElement(ImpText, { typography: "body3", color: state === 'complete' || state === 'current'
                    ? COMPLETE_COLOR
                    : INCOMPLETE_COLOR, transition: `color ${TRANSITION_DURATION} ${TRANSITION_DURATION}` }, label));
        }
    };
    return (React.createElement(OnTopItem, { textAlign: align, position: position, dataTestId: "on-top-item" },
        React.createElement(ImpFlex, { fluid: true, direction: "column", gap: "s", align: align },
            React.createElement(Circle, { position: position, complete: state === 'complete' || state === 'current', height: CIRCLE_SIZE, width: CIRCLE_SIZE, borderRadius: CIRCLE_BORDER_RADIUS, border: CIRCLE_BORDER, dataTestId: "checkpoint" },
                React.createElement(ImpFlex, { fluid: true, align: "center", justify: "center" }, content())),
            React.createElement(TextContainer, null,
                React.createElement(ImpText, { color: state === 'incomplete'
                        ? colors.content.onSurfaceVariant
                        : colors.content.onSurface }, label)))));
}
//# sourceMappingURL=ImpTrackerItem.js.map